import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  listBoxStyle: {
    padding: 0,
    margin: 0,
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  listItemStyle: {
    marginRight: 2,
    marginVertical: 1,
    maxWidth: "100%",
  },
  truncatedButtonStyle: {
    fontSize: 3,
    fontWeight: "700",
    backgroundColor: "none",
    borderWidth: 0,
    alignSelf: "center",
    paddingHorizontal: 0,
    marginTop: 19,
  },
  fixedHeightStyle: {
    overflow: "hidden",
  },
  expandButtonWrapper: {
    alignSelf: "flex-start",
    marginTop: 8,
  },
});
